// extracted by mini-css-extract-plugin
module.exports = {"link":"_1uW-a","container":"lxLp3","title":"_2pzEH","description":"_3EBLD","arrow":"_1pHEg"};